export const ecommerceGettingStartedArticle = {
  title: 'Ecommerce Hub: Getting Started',
  slug: 'ecommerce-getting-started',
  content: `Ecommerce Hub: Getting Started

Generate product content and manage ecommerce copy in one hub.

1) Open Ecommerce Hub
- Go to /marketing/ecommerce-hub.
- Tabs use URL hashes (#product-descriptions, #product-titles, #category-pages, #product-reviews, #bulk-import).

2) Create product content
- Descriptions and Titles tabs generate product copy.

3) Category and reviews
- Category Pages and Reviews tabs create supporting content.

4) Bulk import
- Use Bulk Import for batch content workflows.
`,
};
